import React from "react";
import { observer } from "mobx-react-lite";
import { NumericInput, FormGroup, Intent } from "@blueprintjs/core";
import { INumericAttrEditorProps, EditorWithFormGroup } from "./_types";

// NumericAttrEditor
export const NumericAttrEditor = observer(<D, K extends keyof D>(props: INumericAttrEditorProps<D, K>) => {
	const { store, name, numericInputGroupProps } = props;

	// Change handler
	const onValueChange = (value: number) => {
		store.set(props.name, value);
	};

	// --

	return (
		<NumericInput
			onValueChange={onValueChange}
			value={(store.data[props.name] as string) ?? props.defaultValue ?? ""}
			{...numericInputGroupProps}
			name={name as string}
		/>
	);
});

// NumericAttrEditorGrouo
export const NumericAttrEditorGroup = <D, K extends keyof D>(props: EditorWithFormGroup<INumericAttrEditorProps<D, K>>) => {
	// --

	return (
		<FormGroup {...props.formGroupProps}>
			<NumericAttrEditor numericInputGroupProps={props.numericInputGroupProps} store={props.store} name={props.name} />
		</FormGroup>
	);
};

// NumericAttrEditorGroup
export const NumericAttrEditorGroupWithError = observer(<D, K extends keyof D>(props: EditorWithFormGroup<INumericAttrEditorProps<D, K>>) => {
	const error = props.store.validation.errors.get(props.name);
	const intent: Intent = error ? "danger" : props.numericInputGroupProps.intent;

	// --

	return (
		<FormGroup
			{...props.formGroupProps}
			helperText={<span dangerouslySetInnerHTML={{ __html: error ?? (props.formGroupProps.helperText as any) ?? "&nbsp;" }} />}
			intent={intent}
		>
			<NumericAttrEditor numericInputGroupProps={{ ...props.numericInputGroupProps, intent }} store={props.store} name={props.name} />
		</FormGroup>
	);
});
